export default "__VITE_ASSET__Dvot7miF__"